import React, { useContext } from 'react'
import { Flex } from 'pcln-design-system'
import Pricebreakers from './Promos/Pricebreakers/Pricebreakers'
import VIPPromo from './Promos/VIP/VIPPromo'
import BootstrapDataContext from '../context/BootstrapDataContext'
import KaleyPromoAdBox from './Promos/IncredibleTile/KaleyPromoAdBox'

export default function PromoFeatureBox() {
  const {
    isMobile = false,
    signInStatus: { signedIn = false }
  } = useContext(BootstrapDataContext)
  return (
    <Flex my={[3, null, 4]} mx="auto" justifyContent="center">
      <Flex style={{ maxWidth: '1280px', flex: '0 1 100%' }} px="20px">
        {signedIn ? (
          <VIPPromo isMobile={isMobile} />
        ) : (
          <Pricebreakers isMobile={isMobile} />
        )}
        {!isMobile && <KaleyPromoAdBox />}
      </Flex>
    </Flex>
  )
}
